import { render, staticRenderFns } from "./showInfo.vue?vue&type=template&id=72523d5a&"
import script from "./showInfo.vue?vue&type=script&lang=js&"
export * from "./showInfo.vue?vue&type=script&lang=js&"
import style0 from "./showInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports